<app-header></app-header>

<main class="main-content">
  <!-- Section principale de conversion -->
  <section class="hero-section" id="hero-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h1 class="hero-title">Convertissez vos PDF en Word</h1>
          <p class="hero-description">
            Transformez vos fichiers PDF en documents Word modifiables en quelques secondes.<br>
            Modifiez vos contrats, rapports ou formulaires en toute simplicité.
          </p>
          
          <div class="upload-container" id="upload-section">
            <div class="upload-box" #uploadBox 
                 [class]="dragOverClass"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event)"
                 (click)="triggerFileInput()">
              <img src="assets/images/UploadIcon.png" alt="Upload" class="upload-icon">
              <p class="upload-text">Glissez-déposez un PDF ou cliquez pour en sélectionner un</p>
              
              <!-- Affichage du fichier sélectionné -->
              <div *ngIf="selectedFile" class="selected-file">
                <div class="file-info">
                  <i class="file-icon">📄</i>
                  <span class="file-name">{{ selectedFile.name }}</span>
                  <span class="file-size">({{ selectedFile ? (selectedFile.size / 1024 / 1024).toFixed(2) : '0' }} MB)</span>
                </div>
                <button 
                  type="button" 
                  class="btn btn-success convert-btn" 
                  [disabled]="isLoading"
                  (click)="convertToWord(); $event.stopPropagation()">
                  <span *ngIf="!isLoading">CONVERTIR EN WORD</span>
                  <span *ngIf="isLoading">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    CONVERSION EN COURS...
                  </span>
                </button>
              </div>
            </div>
            
            <!-- Input file caché -->
            <input 
              type="file" 
              id="fileInput" 
              accept=".pdf,application/pdf" 
              (change)="onFileSelected($event)"
              style="display: none;">
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section Modifiez vos PDF sans contraintes -->
  <section class="features-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="feature-image">
            <img src="assets/images/picto01.png" alt="Conversion PDF to Word" class="img-fluid" fetchpriority="high" loading="eager">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="feature-content">
            <h2 class="feature-title">Modifiez vos PDF sans contraintes</h2>
            <p class="feature-description">
              Une fois convertis, vos documents Word sont prêts à être modifiés: corrigez du texte, 
              ajustez des images ou mettez à jour vos contenus en toute liberté.
            </p>
            <button class="btn btn-primary" (click)="scrollToUpload()">LANCER UNE CONVERSION</button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section Conversion rapide et sans logiciel -->
  <section class="conversion-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h2 class="conversion-title">Conversion rapide et sans logiciel</h2>
          <p class="conversion-description">
            Transformez vos PDF en fichiers Word modifiables en quelques secondes. Corrigez facilement 
            le texte et mettez à jour vos documents sans contrainte. Aucune installation nécessaire. 
            Fini les fichiers impossibles à modifier.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Section Conservez la mise en page d'origine -->
  <section class="layout-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 order-lg-2">
          <div class="layout-image">
            <img src="assets/images/picto02.png" alt="Préservation de la mise en page" class="img-fluid">
          </div>
        </div>
        <div class="col-lg-6 order-lg-1">
          <div class="layout-content">
            <h2 class="layout-title">Conservez la mise en page d'origine</h2>
            <p class="layout-description">
              Notre technologie préserve la structure de vos fichiers: tableaux, images, polices et 
              marges restent fidèles au document PDF d'origine.
            </p>
            <button class="btn btn-primary" (click)="scrollToUpload()">ÉDITER VOTRE PDF</button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section Rapide. Fiable. Sécurisé. -->
  <section class="benefits-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h2 class="benefits-title">Rapide. Fiable. Sécurisé.</h2>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-4">
          <div class="benefit-card">
            <div class="benefit-icon">
              <img src="assets/images/Icon01.png" alt="Simple et rapide" class="icon-img">
            </div>
            <h3 class="benefit-card-title">Simple et rapide</h3>
            <p class="benefit-card-description">
              Glissez votre PDF, cliquez, et votre document Word est prêt.<br><br>
              Aucun logiciel à installer, aucune connaissance technique requise.
            </p>
          </div>
        </div>
        
        <div class="col-lg-4 mt-4 mt-md-0">
          <div class="benefit-card">
            <div class="benefit-icon">
              <img src="assets/images/Icon02.png" alt="Résultat de qualité" class="icon-img">
            </div>
            <h3 class="benefit-card-title">Résultat de qualité</h3>
            <p class="benefit-card-description">
              Vos documents conservent leur apparence: texte, structure et mise en page sont fidèlement 
              restitués après conversion.
            </p>
          </div>
        </div>
        
        <div class="col-lg-4 mt-4 mt-md-0">
          <div class="benefit-card">
            <div class="benefit-icon">
              <img src="assets/images/Icon03.png" alt="100% sécurisé" class="icon-img">
            </div>
            <h3 class="benefit-card-title">100% sécurisé</h3>
            <p class="benefit-card-description">
              Le service fonctionne directement en ligne, depuis n'importe quel navigateur.<br><br>
              Vos fichiers sont protégés, traités en toute confidentialité, puis automatiquement supprimés.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
